module.exports = __webpack_public_path__ + "e395f4204b3e8045f4443b03931475cf.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/keg.svg
// module id = S35x
// module chunks = 0